class Appointment {
	id = 0;
	date = null;
	planned_course_id = null;
	appointment_location_id = null;
	teacher_id = null;
	teacher = null;
	course_module_id = null;
	course_module = null;
	start_time = null;
	end_time = null;
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Appointment;
